import React from "react";
import { useSelector } from "react-redux";
import {
  ACTING_ADMIN,
  ADMIN,
  EDITOR_ADMIN,
  SUB_ADMIN,
  VIWEER_ADMIN,
} from "../config/roles";
import ActingAdminRide from "./ActingAdminRide";
import AdminRide from "./AdminRide";
import EditAdminRide from "./EditAdminRide";
import SubUserJoyride from "./SubUserRide";
import ViewAdminRide from "./ViewAdminRide";

const ReactJoyRide = () => {
  const { user } = useSelector((state) => state?.auth);
  if (user?.role === ADMIN) {
    return <AdminRide />;
  }
  if (user?.role === SUB_ADMIN) {
    return <SubUserJoyride />;
  }
  if (user?.role === VIWEER_ADMIN) {
    return <ViewAdminRide />;
  }
  if (user?.role === ACTING_ADMIN) {
    return <ActingAdminRide />;
  }
  if (user?.role === EDITOR_ADMIN) {
    return <EditAdminRide />;
  }
  return <></>;
};
export default ReactJoyRide;
